import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { billingKeys } from "@/lib/query-keys";
import type { PaymentRow } from "@/types/domain";

/** Historial de cargos de la suscripción, del más reciente al más antiguo. */
export function usePaymentHistory(enabled: boolean) {
  return useQuery({
    queryKey: billingKeys.payments(),
    enabled,
    queryFn: () => fetchToBackend<PaymentRow[]>("/subscriptions/payments"),
  });
}
